import { render, staticRenderFns } from "./ClientCollectionsCreateIframe.vue?vue&type=template&id=e9a8c452"
import script from "./ClientCollectionsCreateIframe.vue?vue&type=script&lang=js"
export * from "./ClientCollectionsCreateIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports